import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  const categoryLinks = [
    { label: '恋爱韩漫', path: '/category/lianai' },
    { label: '奇幻韩漫', path: '/category/qihuan' },
    { label: '动作韩漫', path: '/category/dongzuo' },
    { label: '悬疑韩漫', path: '/category/xuanyi' },
    { label: '搞笑韩漫', path: '/category/gaoxiao' },
    { label: '剧情韩漫', path: '/category/juqing' },
  ];

  return (
    <footer className="bg-background-900">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-store-2-line text-2xl text-primary-400"></i>
                </div>
                <span className="text-xl font-heading text-background-50">布丁漫画</span>
              </div>
              <p className="text-foreground-400 text-sm leading-relaxed">
                布丁漫画 - 专注韩漫推荐与排行的中文平台。提供免费全集韩漫资源，支持下拉式在线观看，精选热门韩漫推荐，韩系画风剧情一次看个够。
              </p>
            </div>

            <div>
              <h4 className="text-background-50 font-medium mb-4 text-sm">
                韩漫分类
              </h4>
              <div className="grid grid-cols-2 gap-2">
                {categoryLinks.map((link) => (
                  <button
                    key={link.path}
                    onClick={() => {
                      navigate(link.path);
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                    className="text-foreground-400 hover:text-primary-400 text-sm text-left transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </button>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-background-50 font-medium mb-4 text-sm">
                关于我们
              </h4>
              <div className="flex flex-col gap-2">
                <button
                  onClick={() => {
                    navigate('/about');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className="text-foreground-400 hover:text-primary-400 text-sm text-left transition-colors cursor-pointer whitespace-nowrap"
                >
                  品牌介绍
                </button>
                <a href="/about#contact" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">
                  联系我们
                </a>
                <a href="/about#reputation" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">
                  用户口碑
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-700/40 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-xs">
              &copy; {new Date().getFullYear()} 布丁漫画 budingmanhua.com 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-500 hover:text-primary-400 text-xs transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-foreground-500 hover:text-primary-400 text-xs transition-colors whitespace-nowrap">服务条款</a>
              <a href="#" className="text-foreground-500 hover:text-primary-400 text-xs transition-colors whitespace-nowrap">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}